<template>
  <b-table
    sticky-header
    :class="tablestyle(sourceFrom)"
    :no-border-collapse="noCollapse"
    :items="tableValue.items"
    :fields="tableValue.fields"
    head-variant="#6192b1"
    responsive="sm"
    striped
    :filter="filter"
    :busy="tableLoading"
    show-empty
    empty-text="No Records Found"
  >
    <template v-slot:table-busy>
      <div class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong class="ml-2">Loading...</strong>
      </div>
    </template>
    <template slot="numberOfOrders" slot-scope="row">
      <span class="table-number ml-3">{{row.item.numberOfOrders}}</span>
    </template>
    <template slot="value" slot-scope="row">
      <span class="table-number ml-3">{{amountSeprater(row.item.value)}}</span>
    </template>
    <template v-slot:cell(showviewdetails)="row">
      <p class="table-view-details cursor-pointer ml-3" @click="triggerViewDetails(row.item)">
        <span v-if="sourceFrom=='FeedbackHistory'">View Details</span>
        <span v-else>Edit Details</span>
        <img class="ml-1 mb-n1" style="float: right; " alt src="@/assets/sidenav-icon.svg" />
      </p>
    </template>
    <template v-slot:cell(category)="row">
      <span
        class="cursor-pointer view-partner-page"
        @click="triggerPartnerSummary(row.item.category)"
      >{{row.item.category}}</span>
    </template>
    <!-- <template class="p-0 m-0" slot="rating" slot-scope="row">
        <b-progress
          :value="row.item.rating"
          :variant="updateRating(row.item.rating)"
          class="w-90 mb-2"
        ></b-progress>
        <v-progress-linear v-model="row.item.rating" color="amber" height="10" reactive></v-progress-linear>
    </template>-->
    <template v-slot:cell(branchCodeAndName)="row">
      <span>{{row.item.branchCode}} - {{row.item.branchName}}</span>
    </template>
    <template v-slot:cell(categories)="row">
      <ol v-for="(category,index) in row.item.categories" :key="index" :start="(index+1)">
        <li>{{row.item.categories[index]}}</li>
      </ol>
    </template>
    <template v-slot:cell(orderCount)="row">
      <span
        v-if="row.item.orderCount > 0"
        @click="goToSummaryPage(row.item.partnerId, row.item.partnerType)"
        class="branch-details-orderCount"
      >{{row.item.orderCount}}</span>
      <span v-else>{{row.item.orderCount}}</span>
    </template>
    <template v-slot:cell(totalAmount)="row">
      <span
        v-if="row.item.totalAmount > 0"
      >{{row.item.totalAmount}} [{{row.item.nativeCurrencyType}}]</span>
      <span v-else>{{row.item.totalAmount}}</span>
    </template>
    <template v-slot:cell(invoicePaid)="row">
      <span
        v-if="row.item.invoicePaid > 0"
      >{{row.item.invoicePaid}} [{{row.item.nativeCurrencyType}}]</span>
      <span v-else>{{row.item.invoicePaid}}</span>
    </template>

    <template v-slot:cell(partnerTypeABC)="row">
      <span>{{row.item.categoryName}}</span>
    </template>
    <template v-slot:cell(categoriesABC)="row">
      <ol v-for="(category,index) in row.item.categories" :key="index" :start="(index+1)">
        <li>{{row.item.categories[index].categoryName}}</li>
      </ol>
    </template>
    <template v-slot:cell(subCategoriesABC)="row">
      <ol v-for="(category,index) in row.item.subCategories" :key="index" :start="(index+1)">
        <li>{{row.item.subCategories[index].categoryName}}</li>
      </ol>
    </template>

    <template v-slot:cell(documentNumberNABC)="row">
      <span :class="pbcStatus(row.item.statusCode)" class="mr-1"></span>
      <span>{{row.item.documentNumber}}</span>
    </template>
    <template v-slot:cell(partnerTypeNABC)="row">
      <span>{{row.item.partnerTypeDesc}}</span>
    </template>
    <template v-slot:cell(categoriesNABC)="row">
      <ol v-for="(category,index) in row.item.categories" :key="index" :start="(index+1)">
        <li>{{row.item.categories[index].categoryName}}</li>
      </ol>
    </template>
    <template v-slot:cell(subCategoriesNABC)="row">
      <ol v-for="(category,index) in row.item.subCategories" :key="index" :start="(index+1)">
        <li>{{row.item.subCategories[index].categoryName}}</li>
      </ol>
    </template>
    <template v-slot:cell(actionNABC)="row">
      <img
        @click="sendActionStatusNABC(row.item,'edit')"
        class="edit-icon cursor-pointer"
        v-if="row.item.statusCode==7"
        src="@/assets/edit-icon.svg"
      /> &nbsp;
      <span
        v-if="row.item.statusCode==7"
        class="cursor-pointer pbc-submit-button"
        @click="sendActionStatusNABC(row.item,'submit')"
      >Submit</span>
      <span v-else></span>
    </template>
    
  </b-table>
</template>

<script>
export default {
  components: {},
  props: ["tableValue", "tableLoading", "sourceFrom", "filter"],

  data() {
    return {
      itemValue: []
    };
  },
  //   watch: {
  //     items: function() {
  //       var theData = {
  //         somevar: this.messageId
  //         // other object attributes
  //       };

  //       return theData;
  //       console.log(theData);
  //     }
  //     // items: function(value) {
  //     //   this.itemValue = value;
  //     //   console.log(this.itemValue);
  //     // }
  //   },
  created() {
    // this.getItemValue();
  },
  filters: {
    remarksText: function(string) {
      return string.substring(0, 30) + "...";
    }
  },
  methods: {
    amountSeprater(value) {
      if (value) {
        var x = value;
        x = value.toString();
        var afterPoint = "";
        if (x.indexOf(".") > 0)
          afterPoint = x.substring(x.indexOf("."), x.length);
        x = Math.floor(x);
        x = x.toString();
        var lastThree = x.substring(x.length - 3);
        var otherNumbers = x.substring(0, x.length - 3);
        if (otherNumbers != "") lastThree = "," + lastThree;
        var res =
          otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
          lastThree +
          afterPoint;
        return res;
      }
    },
    tablestyle(from) {
      if (from == "FeedbackHistory" || from == "FeedbackDraft") {
        return "feedback-table";
      } else {
        return "table-style";
      }
    },
    triggerViewDetails(details) {
      this.$emit("getFeedbackNumber", details);
    },
    triggerPartnerSummary(details) {
      this.$emit("navigatePartnerSummary", details);
    },
    // getItemValue() {
    //   console.log(this.items);
    //   this.items.forEach(element => {
    //     if (element.RESPONSE === "Satisfied") {
    //     }
    //   });
    // }
    updateRating(value) {
      if (value > 75) {
        return "success";
      }
      if (value > 50 && value <= 75) {
        return "warning";
      }
      if (value <= 50 && value >= 40) {
        return "info";
      }
      if (value < 40) {
        return "danger";
      }
    },
    goToSummaryPage(partnerId, partnerType) {
      this.$router.push({
        name: "PartnerSummary",
        params: {
          partnerId: partnerId,
          partnerJobType: partnerType
        }
      });
    },
    sendActionStatusNABC(event1, event2) {
      if (event2 == "edit") {
        this.$emit("editDetailsPBC", event1);
      } else {
        this.$emit("submitDetailsPBC", event1);
      }
    },
    pbcStatus(status) {
      if (status == 4) {
        return "yellow-dot";
      } else if (status == 2) {
        return "blue-dot";
      } else if (status == 3) {
        return "red-dot";
      } else if (status == 7) {
        return "orange-dot";
      }
    }
  }
};
</script>

<style>
.thClass {
  background-color: #6192b1 !important;
  color: white;
  text-align: left !important;
}

.thClassCenter {
  background-color: #6192b1;
  color: white;
  text-align: center !important;
}
.thclassleftwidth {
  background-color: #6192b1;
  color: white;
  text-align: left !important;
  width: 15%;
}
.thclassleftwidthofProspective {
  background-color: #6192b1;
  color: white;
  text-align: left !important;
  width: 2%;
}
.thclassrightwidthofProspective {
  background-color: #6192b1;
  color: white;
  /* text-align: left !important; */
  width: 15%;
}
.thclassrightwidth {
  background-color: #6192b1;
  color: white;
  text-align: right !important;
  width: 10%;
}
.table-view-details {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #0e5d84;
}
.table-value {
  text-align: left;
}
.table-number {
  text-align: right !important;
}
.table-style {
  max-height: 265px !important;
  overflow: auto;
  font-size: 14px;
  font-family: "Source Sans Pro", sans-serif;
}
.feedback-table {
  max-height: 600px !important;
  overflow: auto;
  font-size: 14px;
  font-family: "Source Sans Pro", sans-serif;
}
.view-partner-page:hover {
  text-decoration: underline;
}
/* .partner-card > thead {
  position: sticky;
} */
.branch-details-orderCount {
  cursor: pointer;
}
.branch-details-orderCount:hover {
  text-decoration: underline;
  color: #002d72 !important;
  font-weight: bold;
}
.pbc-submit-button {
  text-align: left;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #0e5d84;
}
.edit-icon {
  /* width: 20px !important; */
  max-height: 13px;
}
.orange-dot {
  height: 10px;
  width: 10px;
  background-color: orange;
  border-radius: 50%;
  display: inline-block;
}
.red-dot {
  height: 10px;
  width: 10px;
  background-color: #f43b3b;
  border-radius: 50%;
  display: inline-block;
}
.yellow-dot {
  height: 10px;
  width: 10px;
  background-color: #f4cf08;
  border-radius: 50%;
  display: inline-block;
}
.blue-dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: #002d72;
}
.green-dot {
  height: 10px;
  width: 10px;
  background-color: #62a94b;
  border-radius: 50%;
  display: inline-block;
}
</style>

